<template>
    <v-menu
        ref="menu1"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="20"
        :return-value.sync="localValue"
        lazy
        :disabled="disabled"
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px">
            <template v-slot:activator="{ on }">
            <v-text-field
                :value="selectedDateDescription"
                :label="label"
                append-icon="event"
                readonly
                outline
                :rules="requiredRule"
                :clearable="clearable && !disabled"
                @click:clear="clear"
                v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker scrollable
                :value="editValue"                
                @input="updateValue">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
                <v-btn text color="primary" @click="submit()">OK</v-btn>
            </v-date-picker>
        </v-menu>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        value: {
            required: true
        },
        label: {
            type: String,
            default: "Date"
        },
        clearable: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            menu: false,
            editMode: false,
            localValue: null,
            requiredRule: [v => (!!v || !this.required) || 'Required'],
        };
    },
    computed: {
        editValue(){
            if (!this.value && this.localValue == null) {
                return moment().format('YYYY-MM-DD');
            }

            if(this.localValue == null){
                return moment(this.value).format('YYYY-MM-DD');
            }

            return moment(this.localValue).format('YYYY-MM-DD');
        },
        selectedDateDescription(){
            return this.$options.filters.formatDate(this.value)
        }
    },
    methods: {
        open(){
            this.editMode = true;
        },
        updateValue(newValue){
            this.localValue = moment(newValue, "YYYY-MM-DD").format('YYYY-MM-DD');
        },
        cancel(){
            this.localValue = null;
            this.editMode = false;
            this.menu = false;
        },
        clear() {
            this.$emit("input", "");
            this.localValue = null;
            this.editMode = false;
            this.menu = false;
        },
        submit(){
            this.$emit("input", moment(this.editValue, "YYYY-MM-DD").format('YYYY-MM-DD'));
            this.localValue = null;
            this.editMode = false;
            this.menu = false;
        }
    },
    created(){
        
    }
}
</script>